<template>
  <div>
    <div v-if="itemsAsideMenu === assetItemsAsideMenu">
      <div
        v-show="nodosActivos.length"
        class="m-edition-section-navigation-menu-progress-bar"
      >
        <p class="font-size-small">
          {{ `${porcentajeVisto}% ${$t('mEditionMenu.progress')}` }}
        </p>
        <div class="a-progress-bar margin-bottom-medium">
          <div
            class="a-progress-bar-value"
            :style="{ width: porcentajeVisto + '%' }">
          </div>
        </div>
      </div>

      <div
        v-show="nodosActivos.length"
        class="m-edition-section-navigation-menu-search"
      >
        <div class="m-dropdown-primary">
          <div class="display-flex-row-center">
            <i class="far fa-search"></i>
            <AtomInputPrimary
              v-model="busqueda"
              autocomplete="off"
              :inputError="errorBusqueda"
              :messageError="$t('mEditionMenu.inputSearch.messageError')"
              name="buscar"
              :placeholder="$t('mEditionMenu.inputSearch.placeholder')"
              type="text"
            />
          </div>
          <MoleculeEditionSectionNavigationMenuDropDownSearch
            :info="{ nodosActivos: nodosActivos }"
            :resultados="resultados"
          />
        </div>
      </div>

      <div class="m-edition-asset-contents">
        <transition-group
          class="m-edition-asset-contents-list"
          name="a-transtion-slide"
          tag="ul"
        >
          <MoleculeEditionAssetContentsTreeNode
            v-for="nodo in nodos"
            :key="nodo.id"
            :contenido="contenidos[0]"
            :info="{ nodosActivos: nodosActivos }"
            :is-child="false"
            :nodo="nodo"
          />
        </transition-group>
      </div>
    </div>

    <div
      v-else
      class="m-edition-section-navigation-menu"
    >
      <AtomEditionSectionNavigationMenu
        :itemsAsideMenu="itemsAsideMenu"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionNavigationMenu',

  components: {
    MoleculeEditionAssetContentsTreeNode: () => import('@/components/molecules/MoleculeEditionAssetContentsTreeNode'),
    MoleculeEditionSectionNavigationMenuDropDownSearch: () => import('@/components/molecules/MoleculeEditionSectionNavigationMenuDropDownSearch')
  },

  data () {
    return {
      accountItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-smile',
          subject: `${this.$t('mEditionMenu.account.profile.subject')}`,
          text: `${this.$t('mEditionMenu.account.profile.text')}`,
          to: `/${this.$t('rPaths.account')}/${this.$t('mEditionMenu.account.profile.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-lock-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.account.security.subject')}`,
          text: `${this.$t('mEditionMenu.account.security.text')}`,
          to: `/${this.$t('rPaths.account')}/${this.$t('mEditionMenu.account.security.subject')}`
        }
      ],

      assetItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-file-alt',
          subject: `${this.$t('mEditionMenu.asset.content.subject')}`,
          text: `${this.$t('mEditionMenu.asset.content.text')}`,
          to: `/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.content.subject')}`
        }
      ],

      billingItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-file-invoice-dollar',
          subject: `${this.$t('mEditionMenu.billing.myShopping.subject')}`,
          text: `${this.$t('mEditionMenu.billing.myShopping.text')}`,
          to: `/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myShopping.subject')}`
        }
      ],

      busqueda: '',
      errorBusqueda: false,

      itemClasses: {
        account: 'm-item-aside-account',
        billing: 'm-item-aside-billing'
      },

      resultados: null
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    },

    contenidos () {
      return this.$store.getters.getProyectContents
    },

    itemsAsideMenu () {
      let menu = []
      switch (this.$route.meta.isEdition) {
        case 'account':
          menu = this.accountItemsAsideMenu
          break

        case 'asset':
          menu = this.assetItemsAsideMenu
          break

        case 'billing':
          menu = this.billingItemsAsideMenu
          break
      }
      return menu
    },

    nodos () {
      return this.$store.getters.getProyectNodes
    },

    nodosActivos () {
      return this.$store.getters.getProyectNodesEnrollment
    },

    porcentajeVisto () {
      let total = this.nodosActivos.length
      let vistos = this.nodosActivos.reduce((acc, cur) => {
        if (cur.visto === true) {
          return acc + 1
        } else {
          return acc
        }
      }, 0)
      let porcentaje = Math.round((vistos / total) * 100)
      return porcentaje
    },

    section () {
      return this.$route.meta.isEdition === 'asset' ? `${this.$route.meta.isEdition}s` : this.$route.meta.isEdition
    }
  },

  watch: {
    $route (to, from) {
      this.setItemAsideClasses()
      this.busqueda = ''
    },

    busqueda () {
      if (this.busqueda === '') {
        this.errorBusqueda = false
        this.resultados = null
        this.$dropDown.closeDropDown('MoleculeEditionSectionNavigationMenuDropDownSearch')
      } else {
        this.resultados = this.searchTree(this.nodos, this.busqueda)
        if (this.resultados !== null) {
          this.errorBusqueda = false
          this.$dropDown.openDropDown('MoleculeEditionSectionNavigationMenuDropDownSearch')
        } else {
          // this.errorBusqueda = true
          this.$dropDown.closeDropDown('MoleculeEditionSectionNavigationMenuDropDownSearch')
        }
      }
    },

    billingItemsAsideMenu: {
      handler () {
        if (!(!this.$store.getters.getIsClientData ||
          (this.$store.getters.getClientData &&
          this.$store.getters.getClientData.datos_personales &&
          this.$store.getters.getClientData.datos_personales.documento &&
          this.$store.getters.getClientData.datos_personales.documento.numero !== '0'))) {
          var index = this.billingItemsAsideMenu.findIndex(billing => billing.text === this.$t('mEditionMenu.billing.dataInvoice.text'))
          if (index !== -1) {
            this.billingItemsAsideMenu.splice(index, 1)
          }
        }
      },

      immediate: true
    },

    nodosActivos () {
      this.setNodosPadresVistos(this.nodos)
    }
  },

  created () {
    this.itemClasses['billing'] = this.academyDataColor
      ? 'm-item-aside-academy'
      : this.itemClasses['billing']
    this.setItemAsideClasses()
  },

  methods: {
    checkNodoActivo (nodo) {
      let nodoActivo = this.nodosActivos.find(anodo => anodo.nodo === nodo.id)
      return nodoActivo !== undefined
    },

    searchTree (tree, text) {
      let array = []

      tree.forEach(nodo => {
        let node = nodo.texto.length > 0 ? JSON.parse(nodo.texto) : { blocks: [] }
        if (this.checkNodoActivo(nodo) && node.blocks.length > 0) {
          var nodoNorm = nodo.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          var textNorm = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          if (nodoNorm.toLowerCase().includes(textNorm.toLowerCase())) {
            array.push(nodo)
          }
        }
        if (nodo.children.length > 0) {
          let aux = this.searchTree(nodo.children, text)
          if (aux != null) {
            array.push(...aux)
          }
        }
      })

      if (array.length > 0) {
        return array
      } else {
        return null
      }
    },

    setItemAsideClasses () {
      this.itemsAsideMenu.forEach(itemAside => {
        itemAside.class = itemAside.subject === this.$route.params.subject
          ? `m-item-aside-active ${this.itemClasses[this.$route.meta.isEdition]}-active`
          : this.itemClasses[this.$route.meta.isEdition]
      })
    },

    setNodosPadresVistos (nodos) {
      nodos.forEach(nodo => {
        if (this.nodosActivos.find(activo => activo.nodo === nodo.id) &&
          (nodo.texto.length === 0 || JSON.parse(nodo.texto).blocks.length === 0) &&
          nodo.children.length > 0) {
          this.setNodosPadresVistos(nodo.children)
          this.setNodoVisto(nodo)
        }
      })
    },

    setNodoVisto (nodo) {
      let activeChildren = []
      let activeIndex = this.nodosActivos.findIndex(activo => activo.nodo === nodo.id)
      nodo.children.forEach(child => {
        activeChildren.push(this.nodosActivos.find(activo => activo.nodo === child.id))
      })

      if (activeChildren.every(child => {
        return child.visto
      })) {
        this.nodosActivos[activeIndex].visto = true
      } else {
        this.nodosActivos[activeIndex].visto = false
      }
    }
  }
}
</script>
